import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { EmbeddedSignComponent } from './embedded-sign/embedded-sign.component';
import { EmbeddedComponent } from './pages/embedded/embedded.component';
import { FormComponent } from './pages/form/form.component';
import { LandingComponent } from './pages/landing/landing.component';
import { SignaturesComponent } from './pages/signatures/signatures.component';
import { WelcomeAuthenticateComponent } from './pages/welcome/authenticate/authenticate.component';
import { WelcomeCustomerDetailsComponent } from './pages/welcome/customer-details/customer-details.component';
import { WelcomePurchaseConfigureComponent } from './pages/welcome/purchase-configure/purchase-configure.component';
import { WelcomePurchaseFormComponent } from './pages/welcome/purchase-form/purchase-form.component';
import { WelcomePurchaseQuotesComponent } from './pages/welcome/purchase-quotes/purchase-quotes.component';
import { WelcomeSubscriptionTypeComponent } from './pages/welcome/subscription-type/subscription-type.component';
import { WelcomeTrialFormComponent } from './pages/welcome/trial-form/trial-form.component';

const routes: Routes = [
	{ path: '', component: LandingComponent, canActivate: [] },
	{ path: 'signatures', component: SignaturesComponent, canActivate: [] },
	{ path: 'welcome', component: WelcomeCustomerDetailsComponent, canActivate: [] },
	{ path: 'welcome/type', component: WelcomeSubscriptionTypeComponent, canActivate: [] },
	{ path: 'welcome/trial', component: WelcomeTrialFormComponent, canActivate: [] },
	{ path: 'welcome/purchase', component: WelcomePurchaseFormComponent, canActivate: [] },
	{ path: 'welcome/purchase/configure', component: WelcomePurchaseConfigureComponent, canActivate: [] },
	{ path: 'welcome/purchase/quotes', component: WelcomePurchaseQuotesComponent, canActivate: [] },
	{ path: 'welcome/authenticate', component: WelcomeAuthenticateComponent, canActivate: [] },
	{ path: 'form', component: FormComponent, canActivate: [] },
	{ path: 'embedded', component: EmbeddedComponent, canActivate: [] },
	{ path: 'embedded-sign', component: EmbeddedSignComponent, canActivate: [] }
];

@NgModule({
	imports: [RouterModule.forRoot(routes)],
	exports: [RouterModule]
})
export class AppRoutingModule { }
